// Analytics: forwards to dataLayer (GA4/GTM can subscribe later) AND to the
// first-party analytics API (privacy-first: random session id, no PII).
const getSessionId = () => {
  let id = sessionStorage.getItem("aviah_sid");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || String(Math.random()).slice(2) + Date.now();
    sessionStorage.setItem("aviah_sid", id);
  }
  return id;
};

export const track = (event, data = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event,
        path: data.path || window.location.pathname,
        lang: data.lang || document.documentElement.lang || "en",
        sessionId: getSessionId(),
        device: window.innerWidth < 768 ? "mobile" : "desktop",
      }),
      keepalive: true,
    });
  } catch {
    /* analytics must never break the page */
  }
};
